import { connect } from 'react-redux';
import { fetchCurrentUserFrontChatDataForInstitution } from 'src/ReduxStorage/Auth/dispatchers.common';
import { selectCurrentInstitutionObject } from 'src/ReduxStorage/Institutions/selectors';
import { ReduxState } from 'src/ReduxStorage/state';
import { InstitutionSettingsFrontChat } from './component';

export const ConnectedInstitutionSettingsFrontChat = connect(
  (state: ReduxState) => ({
    institution: selectCurrentInstitutionObject(state),
  }),
  {
    fetchCurrentUserFrontChatDataForInstitution,
  }
)(InstitutionSettingsFrontChat);
